import { VIEW_URL_EXPIRES_IN_SECONDS } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

/** 서명 주소 수명(VIEW_URL_EXPIRES_IN_SECONDS)의 0.8 — 창이 열려 있는 동안 이 주기로 뷰를 다시 받는다(뷰어 설계 V13). */
export const QUOTE_DESIGN_VIEW_REFRESH_MS = VIEW_URL_EXPIRES_IN_SECONDS * 0.8 * 1000;
/**
 * 서명 주소 수명의 0.1(6분) — 창을 다시 열 때 이보다 최근에 받은 뷰만 그대로 쓴다. 다시 연 창은 다음 주기(0.8)까지 그 뷰를 쓰므로
 * 가장 오래된 주소는 0.1 + 0.8 = 수명의 0.9 다(만료 전). 폰트는 만료(403)를 알 수 없어 대체 글꼴로 조용히 바뀌므로 수명 안에 둔다.
 */
export const QUOTE_DESIGN_VIEW_STALE_MS = VIEW_URL_EXPIRES_IN_SECONDS * 0.1 * 1000;

interface MyQuoteDesignViewQueryOptions {
  readonly enabled: boolean;
}

/**
 * 내 견적 디자인 보기(quotes.getDesignView) — 고정 편집영역 정의·폰트·잉크·이미지의 서명 주소판. 본문은 상세(getMine)가 준다.
 * 구독(창)이 있을 때만 주기적으로 다시 받는다 — 창을 닫아 구독이 사라지면 멈춘다.
 */
export const useMyQuoteDesignViewQuery = (
  quoteRequestId: string,
  options: MyQuoteDesignViewQueryOptions,
) =>
  trpc.quotes.getDesignView.useQuery(
    { quoteRequestId },
    {
      enabled: options.enabled,
      // 남의 견적·없는 견적(NOT_FOUND)은 재시도해도 같다.
      retry: false,
      refetchInterval: options.enabled ? QUOTE_DESIGN_VIEW_REFRESH_MS : false,
      // 다시 열 때 받은 지 6분이 안 된 뷰만 그대로 쓴다 — 거기에 주기(48분)를 더해도 주소가 수명(60분) 안이다.
      staleTime: QUOTE_DESIGN_VIEW_STALE_MS,
    },
  );
